module.exports = __webpack_public_path__ + "static/media/Portrait-10063_xmas.76869d9a.jpg";